import React from "react";
import { cx } from "emotion";
import { RouteComponentProps, withRouter } from "react-router";
import { FeedbackSize } from "../../../Constants/feedbackEnums";
import styles from "../../../Styles/FeedbackSizeBadge.module.scss";

type Props = {
  size?: FeedbackSize;
};

// Text for the badge tooltips
const tooltipText = {
  [FeedbackSize.Small]:
    "General: If the feature can be described \x0Ain one sentence. \x0A\x0A" +
    "Dev: and if it isn't reused all over the place",
  [FeedbackSize.Medium]:
    "Design & Dev: limited screen scope, less \x0Achanging requirements, updates to existing",
  [FeedbackSize.Large]:
    "Design: Lots of (new) user  interaction,\x0Apossible changing requirements.\x0A\x0A" +
    "Dev: schema/component behaviour changes,\x0Amay need R&D/investigation, new complicated front end. \x0A\x0A" +
    "General: lots of screen impacts"
};

class FeedbackSizeBadge extends React.Component<Props & RouteComponentProps> {
  render() {
    let text = "S";
    let textStyle = styles.small;

    switch (this.props.size) {
      case FeedbackSize.Small:
        text = "S";
        textStyle = styles.small;
        break;
      case FeedbackSize.Medium:
        text = "M";
        textStyle = styles.medium;
        break;
      case FeedbackSize.Large:
        text = "L";
        textStyle = styles.large;
        break;
      default:
        text = "S";
        break;
    }

    if (this.props.size) {
      return (
        <div className={cx(styles["size-badge"], textStyle)} title={tooltipText[this.props.size]}>
          {text}
        </div>
      );
    }
    return null;
  }
}

export default withRouter(FeedbackSizeBadge);
